import { Document, Page } from '@react-pdf/renderer';
import './style.css';
import { observer } from 'mobx-react-lite';
import Html from 'react-pdf-html';
import ReactDOMServer from 'react-dom/server';
import { metadataType } from '../../../app/api/types';
import { useEffect } from 'react';
import { useStore } from '../../../app/stores/store';
import {
  aSummary,
  elementObject,
  frameDetails,
  label,
  pictureVendor,
  summaryIndex,
  supervisorIndices,
} from './constant';
import { CheckboxHandler, dateConvertHandler } from './ColorGrading';
import { getImageSrc } from '../../../utils/ImageHelper';

const NFAIReelAnalysisReport = ({ modalTitleDetails,isDualPDF } : {modalTitleDetails:string, isDualPDF:boolean}) => {
  const {
    viewStore: { metadata, parentMetadata },
    activityStore: { selectedActivity },
    masteringStore
  } = useStore();
  // const [localMetaData, setLocalMetaData] = useState<any>({});
  // const [dynData, setDynData] = useState<any>({});
  // const [summary, setSummary] = useState<string>('');
  // const [supervisorDetails, setSupervisorDetails] = useState<metadataType[]>(
  //   [],
  // );

  useEffect(() => {
    if (selectedActivity?.id) {
      parentMetadata({ itemId: selectedActivity?.id });
    }
    // eslint-disable-next-line
  }, []);

  const getColumn = (data: any, num: number) => {
    let halfLength = 0;
    halfLength = Math.ceil(data?.length / 2);
    const column1 = data?.slice(0, halfLength);
    const column2 = data?.slice(halfLength);
    if (num === 1) {
      return column1;
    } else {
      return column2;
    }
  };

  const element = (
    <html>
      <body>
        <style>
          {`
          * {
            font-size: 7px;
          }
          #container {
            margin: -6px 20px 0 20px;
          }
        #container tbody {
          column-count:2;
    -moz-column-count:2;
    -webkit-column-count:2;
        }
        .l-grey-bg {
          background-color: lightgray;
        }
        .grey-bg {
          background-color: gray;
        }
        .d-grey-bg {
          background-color: darkslategray;
        }
        .nfai-table {
          width: 90%;
          margin-left: auto;
          margin-right: auto;
        }
        .center-content {
          text-align: center;
        }
          .center-left {
          text-align: left;
        }
        .center-right {
          text-align: right;
        }
        .padding-4 {
          padding: 4px;
        }
        .padding-2 {
          padding: 2px;
        }
        .nfai-table,
        .nfai-table th,
        .nfai-table td {
          border: 1px solid black;
          border-collapse: collapse;
        }
        .nfai-table td {
          padding: 2px;
        }
        .nfai-table table,
        .nfai-table table th, .nfai-table table td {
          border: none;
          border-collapse: collapse;
        }
        .bold {
          font-weight: 700;
        }
        .border-top-0 {
          border-top: 0px;
        }
        .white-text {
          color: white;
        }
        .yellow-bg {
          background-color: #cb9d06;
        }
        `}
        </style>
        <div id="container">
          <table className="nfai-table">
            <thead>
              <tr>
                <th className="center-content padding-4 bold">
                  Analysis/ QC Report
                </th>
              </tr>
              <tr>
                <th className="l-grey-bg center-content padding-2 bold">
                  NFHM Restoration Project
                </th>
              </tr>
              <tr>
                <th className="grey-bg center-content padding-2 bold white-text">
                  PICTURE VENDOR NAME: Prasad Corporation Private Limited,
                  Chennai
                </th>
              </tr>
            </thead>
            <tbody>
              {getColumn(masteringStore.ReelAnalysisData.localMetaData[0], 1)?.map(
                (l: metadataType, index: number) => {
                  return (
                    <tr key={l.elementIndex}>
                      <td className='center-left'>
                        {label[l.elementName as keyof typeof label] !==
                        undefined
                          ? label[l.elementName as keyof typeof label].replace('Title Name','Title')
                          : l.elementName}
                        :
                      </td>
                      <td className="center-content center-left">
                        {l?.options?.length !== 0
                          ? CheckboxHandler(l.options, l.elementValue,'left','RealAnalysisReport')
                          :  l.elementValue}
                      </td>
                      <td  className='center-right'>
                        {label[
                          getColumn(masteringStore.ReelAnalysisData.localMetaData[0], 2)?.[index]
                            ?.elementName as keyof typeof label
                        ] !== undefined
                          ? label[
                              getColumn(masteringStore.ReelAnalysisData.localMetaData[0], 2)?.[index]
                                ?.elementName as keyof typeof label
                            ]
                          : getColumn(masteringStore.ReelAnalysisData.localMetaData[0], 2)?.[index]
                              ?.elementName}
                        :
                      </td>
                      <td className="center-content center-left">
                        {/* <img src='https://res.cloudinary.com/drvaemi9t/image/upload/v1703072153/dlvjshb1zivgxghml5q7.png' style={{width:'10px',height:'10'}}/> */}
                        {getColumn(masteringStore.ReelAnalysisData.localMetaData[0], 2)?.[index]?.options
                          ?.length !== 0
                          ? CheckboxHandler(
                              getColumn(masteringStore.ReelAnalysisData.localMetaData[0], 2)?.[index].options,
                              getColumn(masteringStore.ReelAnalysisData.localMetaData[0], 2)?.[index]
                                ?.elementValue,'left','RealAnalysisReport'
                            )
                          : getColumn(masteringStore.ReelAnalysisData.localMetaData[0], 2)?.[index]
                          ?.elementType === 'DatePicker' ?
                          dateConvertHandler(getColumn(masteringStore.ReelAnalysisData.localMetaData[0], 2)?.[index]
                              ?.elementValue,'typeFirst')
                          : 
                           getColumn(masteringStore.ReelAnalysisData.localMetaData[0], 2)?.[index]
                              ?.elementValue}
                        {/* {getColumn(localMetaData[0], 2)?.[index]?.elementValue} */}
                      </td>
                    </tr>
                  );
                },
              )}
            </tbody>
          </table>
          <table className="nfai-table border-top-0">
            <thead className="border-top-0">
              <tr>
                <th className="center-content padding-2 bold grey-bg border-top-0 white-text">
                  A - Summary
                </th>
              </tr>
            </thead>
            <tbody>
              {getColumn(masteringStore.ReelAnalysisData.localMetaData[1], 1)?.map(
                (l: metadataType, ind: number) => {
                  return (
                    <tr key={l.elementIndex}>
                      <td  className='center-left'>
                        {label[l.elementName as keyof typeof label] !==
                        undefined
                          ? label[l.elementName as keyof typeof label]
                          : l.elementName}
                      </td>
                      <td className="center-content center-left" >
                       {
                      //  l.elementName === 'Bit Depth' ?
                      //  (l.options.map((ops:any, index:number) => (
                      //   <span key={index}>
                      //     <img
                      //       src='../assets/NFAI_Restoration_Checkbox_Checked.png'
                      //       alt={`Checkbox for ${ops.optionName}`}
                      //       style={{ width: '10px', height: '10px', marginRight: '1px' }}
                      //     />
                      //     <span>{ops.optionName} Bit</span>
                      //   </span>
                      // ))) :
                       l?.options?.length !== 0
                        ? CheckboxHandler(l.options, l.elementValue, l.elementName === 'Bit Depth'? 'Bit Depth' : 'left', 'RealAnalysisReport')
                        : ['Input Format/Medium', 'Delivery Format/Medium'].includes(l.elementName) && !l.elementValue?.includes('dpx')
                        ? `${l.elementValue} | dpx |`
                        : l.elementName === 'Asset ID'
                        ? <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '-1px' }}> 
                        {l.elementValue?.split('|').length === 1 ? l.elementValue : (l.elementValue?.split('|').map((value, index) => (
                                <div key={index} style={{ display: 'flex', flexDirection:'row' }}>
                                  <img
                                    src='../assets/NFAI_Restoration_Checkbox_Checked.png'
                                    alt={`Checkbox for ${value}`}
                                    style={{ width: '10px', height: '10px', marginRight: '1px' }}
                                  />
                                  <span>{value}</span>
                                </div>
                              )))}</div>
                  : l.elementValue }
                      </td>
                      <td  className='center-right'>
                        {label[
                          getColumn(masteringStore.ReelAnalysisData.localMetaData[1], 2)?.[ind]
                            ?.elementName as keyof typeof label
                        ] !== undefined
                          ? label[
                              getColumn(masteringStore.ReelAnalysisData.localMetaData[1], 2)?.[ind]
                                ?.elementName as keyof typeof label
                            ]
                          : getColumn(masteringStore.ReelAnalysisData.localMetaData[1], 2)?.[ind]?.elementName}
                        {/* {getColumn(localMetaData[1], 2)?.[ind]?.elementName} */}
                      </td>
                      <td
                        className="center-content center-left"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                        }}
                      >
                        {getColumn(masteringStore.ReelAnalysisData.localMetaData[1], 2)?.[ind]?.elementName === 'Bit Depth' ?  <div style={{ display: 'flex', flexDirection: 'row',}}> 
                          {getColumn(masteringStore.ReelAnalysisData.localMetaData[1], 2)?.[ind]?.elementValue?.split('|').length === 1 ?
                           `${getColumn(masteringStore.ReelAnalysisData.localMetaData[1], 2)?.[ind]?.elementValue} Bit` : 
                            (getColumn(masteringStore.ReelAnalysisData.localMetaData[1], 2)?.[ind]?.elementValue?.split('|').map((value:any, index:number) => (
                                  <div key={index} style={{ display: 'flex', flexDirection:'row', margin: '0 1px' }}>
                                    <img
                                      src='../assets/NFAI_Restoration_Checkbox_Checked.png'
                                      alt={`Checkbox for ${value}`}
                                      style={{ width: '10px', height: '10px', marginRight: '1px' }}
                                    />
                                    <span>{value} Bit</span>
                                  </div>
                                )))}</div> 
                          : getColumn(masteringStore.ReelAnalysisData.localMetaData[1], 2)?.[ind]?.options
                          ?.length !== 0
                          ? CheckboxHandler(
                              getColumn(masteringStore.ReelAnalysisData.localMetaData[1], 2)?.[ind]?.options,
                              getColumn(masteringStore.ReelAnalysisData.localMetaData[1], 2)?.[ind]
                                ?.elementValue,'left','RealAnalysisReport'
                            )
                          :  ['Input Format/Medium', 'Delivery Format/Medium'].includes(getColumn(masteringStore.ReelAnalysisData.localMetaData[1], 2)?.[ind]
                          ?.elementName) && !l.elementValue.includes('dpx') ? `${getColumn(masteringStore.ReelAnalysisData.localMetaData[1], 2)?.[ind]?.elementValue} | dpx |` 
                          : getColumn(masteringStore.ReelAnalysisData.localMetaData[1], 2)?.[ind]?.elementValue}
                        {/* {getColumn(localMetaData[1], 2)?.[ind]?.elementValue} */}
                      </td>
                    </tr>
                  );
                },
              )}
            </tbody>
          </table>
          <table className="nfai-table border-top-0">
            <thead className="border-top-0">
              <tr>
                <th className="center-content padding-2 bold grey-bg border-top-0 white-text">
                  Shot Classification
                </th>
              </tr>
              <tr>
                {masteringStore.ReelAnalysisData.dynData['headers']?.map((headerName: string) => {
                  return (
                    <th
                      className="center-content padding-2 bold l-grey-bg center-left"
                      key={headerName}
                    >
                      {headerName}
                    </th>
                  );
                })}
                {masteringStore.ReelAnalysisData.dynData['headers']?.map((headerName: string) => {
                  return (
                    <th
                      className="center-content padding-2 bold l-grey-bg center-left"
                      key={headerName}
                    >
                      {headerName}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {getColumn(masteringStore.ReelAnalysisData.dynData['body'], 1)?.map(
                (bodyData: any, index: number) => {
                  return (
                    <tr>
                      {masteringStore.ReelAnalysisData.dynData['headers']?.map((headerName: string) => {
                        return (
                          <td
                            className={
                              headerName === 'Defects' ? '' : 'center-content'
                            }
                          >
                            {typeof bodyData[headerName] === 'object'
                              ? JSON.stringify(bodyData[headerName])
                              : bodyData[headerName]}
                          </td>
                        );
                      })}
                      {masteringStore.ReelAnalysisData.dynData['headers']?.map((headerName: string) => {
                        return (
                          <>
                            {getColumn(masteringStore.ReelAnalysisData.dynData['body'], 2)?.[index] ? (
                              <td
                                className={
                                  headerName === 'Defects'
                                    ? ''
                                    : 'center-content'
                                }
                              >
                                {
                                  getColumn(masteringStore.ReelAnalysisData.dynData['body'], 2)?.[index]?.[
                                    headerName
                                  ]
                                }
                              </td>
                            ) : (
                              <td></td>
                            )}
                          </>
                        );
                      })}
                    </tr>
                  );
                },
              )}
            </tbody>
          </table>
          <table className="nfai-table border-top-0">
            <thead className="border-top-0">
              <tr>
                <th className="center-content padding-2 bold grey-bg border-top-0 white-text">
                  Summary
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <table>
                    <tbody>
                      {masteringStore.ReelAnalysisData.localMetaData[4]?.map((l: metadataType) => {
                        return (
                          <tr>
                            <td>{l.elementName}</td>
                            <td>{l.elementValue}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </td>
                <td>
                  {masteringStore.ReelAnalysisData.summary}
                </td>
              </tr>
            </tbody>
          </table>
          <table className="nfai-table border-top-0">
            <thead className="border-top-0">
            <tr>
                <td>
                <br /> <br /> <br /> <br /><br />
                  {
                    label[
                      masteringStore.ReelAnalysisData.supervisorDetails?.filter(
                        (s) => s.elementName !== 'Supervisor Comments',
                      )?.[0]?.elementName as keyof typeof label
                    ]?.replaceAll('Name and Signature','')
                  }
                  :
                </td>
                <td>
                <br /> <br /> <br /> <br /><br />
                  {
                    masteringStore.ReelAnalysisData.supervisorDetails?.filter(
                      (s) => s.elementName !== 'Supervisor Comments',
                    )?.[0]?.elementValue
                  }
                </td>
                <td>
                <br /> <br /> <br /> <br /><br />
                  {
                    label[
                      masteringStore.ReelAnalysisData.supervisorDetails?.filter(
                        (s) => s.elementName !== 'Supervisor Comments',
                      )?.[1]?.elementName as keyof typeof label
                    ]
                  }
                  :
                </td>
                <td>
                <br /> <br /> <br /> <br /><br />
                  {dateConvertHandler(
                    masteringStore.ReelAnalysisData.supervisorDetails?.filter(
                      (s) => s.elementName !== 'Supervisor Comments',
                    )?.[1]?.elementValue
                  )}
                </td>
              </tr>

              <tr>
                {masteringStore.ReelAnalysisData.supervisorDetails?.map((s: metadataType) => {
                  return s.elementName === 'Supervisor Comments' ? (
                    <>
                      <br />
                      <br />
                      <th className="padding-2 bold">
                        {label[s.elementName as keyof typeof label]} :{' '}
                        {s.elementValue}
                        <br /> <br /> <br />
                      </th>
                    </>
                  ) : (
                    <></>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                <br /> <br /> <br /> <br /><br />
                  {
                    label[
                      masteringStore.ReelAnalysisData.supervisorDetails?.filter(
                        (s) => s.elementName !== 'Supervisor Comments',
                      )?.[2]?.elementName as keyof typeof label
                    ]
                  }
                  :
                </td>
                <td>
                <br /> <br /> <br /> <br /><br />
                  {
                    masteringStore.ReelAnalysisData.supervisorDetails?.filter(
                      (s) => s.elementName !== 'Supervisor Comments',
                    )?.[2]?.elementValue?.split('|')[1]
                  }
                </td>
                <td>
                <br /> <br /> <br /> <br /><br />
                  {
                    label[
                      masteringStore.ReelAnalysisData.supervisorDetails?.filter(
                        (s) => s.elementName !== 'Supervisor Comments',
                      )?.[3]?.elementName as keyof typeof label
                    ]
                  }
                  :
                </td>
                {modalTitleDetails.includes('Final Restoration') 
                ? null :  <td>
                <br /> <br /> <br /> <br /><br />
                  {dateConvertHandler(
                    masteringStore.ReelAnalysisData.supervisorDetails?.filter(
                      (s) => s.elementName !== 'Supervisor Comments',
                    )?.[3]?.elementValue
                  )}
                </td>}
              </tr>
            </tbody>
          </table>
          {isDualPDF ? 
                        <div style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                      {/* eslint-disable-next-line */}
                      <img 
                        src={getImageSrc('bala')} 
                        style={{ width: 65, height: 35, marginTop: 20 }} 
                      />
                    </div> : null}
        </div>
      </body>
    </html>
  );

  const getDynamicTableData = (eleVal: string) => {
    const temp: any = {};
    temp['headers'] = [];
    temp['body'] = [];
    // temp['body2'] = [];
    let columnHeaders: string[] = [];
    let tempValue = [];
    if (eleVal?.includes('DynamicTable|')) {
      let stringData = eleVal?.split('DynamicTable|')?.[1]?.replaceAll(/\n/g,'');
      stringData = stringData?.split('_')?.join(' ');
      tempValue = stringData !== undefined ? JSON.parse(stringData) : [];
      columnHeaders = Object.keys(tempValue[0] || []);  
      columnHeaders = columnHeaders?.filter((data) => data !== ' uuid ');
      tempValue = tempValue.map((item:any) => {
        const numberOfFramesAffected = item["Number of Frames Affected"].toString();
        return {
            ...item,
            "Number of Frames Affected": numberOfFramesAffected === "0" ? "" : numberOfFramesAffected
        };
    });
    
    }
    temp['headers'] = columnHeaders;
    temp['body'] = tempValue;
    masteringStore.ReelAnalysisData.dynData = temp;
    // setDynData(temp);
  };

  useEffect(() => {
    const tempTableData: any = {};

    tempTableData[0] = [];
    tempTableData[1] = [];
    tempTableData[4] = [];

    const tempSupervisor: metadataType[] = [];
    const bitValue = metadata.find((el) => el.elementName === 'Bit Depth')?.elementValue || '';
        const tempMetadata = [...metadata];
        tempMetadata.push({
          ...elementObject,
          elementName: 'Bit rate',
          elementValue: `${bitValue} Bit`,
          enableByDefault: true,
        });
    // eslint-disable-next-line
    tempMetadata?.flatMap((m: metadataType) => {
      // eslint-disable-next-line
      if (pictureVendor.includes(m.elementName)) {
        tempTableData[0][pictureVendor.indexOf(m.elementName)] = m;
      }
      if (aSummary.includes(m.elementName)) {
        tempTableData[1][aSummary.indexOf(m.elementName)] = m;
      }
      if (m.elementType === 'DynamicTable' && m.elementName?.includes('Shot')) {
        getDynamicTableData(m.elementValue);
      }
      if (summaryIndex.includes(m.elementName)) {
        masteringStore.ReelAnalysisData.summary = m.elementValue;
        // setSummary(m.elementValue);
      }
      if (supervisorIndices.includes(m.elementName)) {
        tempSupervisor[supervisorIndices.indexOf(m.elementName)] = m;
      }
      if (frameDetails.includes(m.elementName)) {
        tempTableData[4][frameDetails.indexOf(m.elementName)] = m;
      }
         });
    const filmElement = metadata.find(
      (element) => element.elementName === 'Film Element',
    );
    const Asset_Id = metadata.find(
      (element) => element.elementName === 'Asset ID',
    );
    tempTableData[1] = tempTableData[1].map((element: any) => {
      if (element.elementName === 'Asset ID') {
        return {
          ...element,
          elementValue:
        filmElement?.elementValue + ', ' + (Asset_Id?.elementValue || ''),
        };
      }
      return element;
    }); 
    masteringStore.ReelAnalysisData.localMetaData = tempTableData;
    masteringStore.ReelAnalysisData.supervisorDetails = tempSupervisor;
    // setLocalMetaData(tempTableData);
    // setSupervisorDetails(tempSupervisor);
     // eslint-disable-next-line
  }, [metadata]);
  
  const html = ReactDOMServer.renderToStaticMarkup(element);
  return (
    <Document>
      <Page style={{ padding: '18px' }}>
        <Html>{html}</Html>
      </Page>
    </Document>
  );
};

export default observer(NFAIReelAnalysisReport);
